module.exports = __webpack_public_path__ + "img/keep-it-up.2d526623.svg";